export interface IItem {
  id: number;
  video_type?: 'hls' | null;
  type: ItemType;
  status?: string;
  filename_download: string;
  isDownload?: boolean;
}

export enum ItemType {
  Report = 'report',
  Video = 'video'
}
